import { RadioField, RadioInput } from '@flos/react-ui';
import { type AttributeChangeProps } from '../../../types';
import { useRecoilValue, useSetRecoilState } from 'recoil';
import { isOpcDataFilledAtom } from '../../../../../recoil/atoms/isOpcDataFilledAtom';
import type { YesNo_Top } from 'gw-edge-client/dist/types/dto/pc/typekey';
import { useState } from 'react';
import { getCoverableInfoSelector } from '../../../../../recoil/selectors/getCoverableInfoSelector';

export const fireplaceOptions: Array<{ label: string; value: YesNo_Top }> = [
    {
        label: 'Ja',
        value: 'Yes'
    },
    {
        label: 'Nej',
        value: 'No'
    }
];

const HolidayHomeFirePlaceChange = ({
    updateCoverableAttribute,
    additionalProps
}: AttributeChangeProps): React.JSX.Element => {
    const setIsOpcDataFilled = useSetRecoilState(isOpcDataFilledAtom);
    const { isFirePlace } = useRecoilValue(getCoverableInfoSelector);

    const [firePlace, setFirePlace] = useState(isFirePlace ? 'Yes' : 'No');
    const handleChange = (e: React.ChangeEvent<HTMLInputElement>): void => {
        setFirePlace(e.currentTarget.value);
        updateCoverableAttribute({ firePlace: e.currentTarget.value as YesNo_Top });
        setIsOpcDataFilled(true);
    };
    return (
        <RadioField value={firePlace} onChange={handleChange}>
            {fireplaceOptions.map((option) => (
                <RadioInput key={option.value} value={option.value} label={option.label} />
            ))}
        </RadioField>
    );
};

export default HolidayHomeFirePlaceChange;
